import React from 'react';
import { motion } from 'framer-motion';
import { Ornament } from './Ornament';
const testimonials = [{
  quote: 'Pensé que era otro devocional bonito. Pero al tercer día estaba llorando porque por primera vez entendí que mi proceso tenía sentido.',
  author: 'María C.'
}, {
  quote: 'Nunca había conectado mi historia con la de Ester así. Me sentí vista por Dios de una manera que no había sentido en años.',
  author: 'Gabriela R.'
}, {
  quote: 'El Día 7 cambió algo en mí. Ya no veo mi espera como un fracaso.',
  author: 'Patricia L.'
}];
export function Testimonials() {
  return <section className="py-10 px-5" data-id="element-278">
      <div className="max-w-lg mx-auto" data-id="element-279">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-6" data-id="element-280">
          <h2 className="font-serif text-xl sm:text-2xl text-cream-100" data-id="element-281">
            Lo que otras mujeres están descubriendo...
          </h2>
        </motion.div>

        <div className="space-y-3.5" data-id="element-282">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-navy-800/40 p-4 rounded-sm border border-gold-500/20 relative" data-id="element-283">
              <div className="text-gold-500/20 font-serif text-5xl absolute top-1 left-3 leading-none" data-id="element-284">
                "
              </div>
              <p className="relative z-10 font-serif text-base text-cream-200 italic mb-2 pt-1" data-id="element-285">
                "{t.quote}"
              </p>
              <p className="relative z-10 text-gold-400 text-xs font-medium" data-id="element-286">
                — {t.author}
              </p>
            </motion.div>)}
        </div>

        <Ornament className="mt-7" data-id="element-287" />
      </div>
    </section>;
}